import { Routes, Route } from 'react-router-dom'
import { Box } from '@mui/material'
import DashboardLayout from './components/DashboardLayout'
import OverviewPage from './pages/OverviewPage'
import TracksPage from './pages/TracksPage'
import WaypointsPage from './pages/WaypointsPage'
import UsersPage from './pages/UsersPage'
import ModerationPage from './pages/ModerationPage'
import AnalyticsPage from './pages/AnalyticsPage'
import SystemHealthPage from './pages/SystemHealthPage'
import DevPage from './pages/DevPage'

function App() {
  return (
    <Box sx={{ display: 'flex' }}>
      <DashboardLayout>
        <Routes>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/tracks" element={<TracksPage />} />
          <Route path="/waypoints" element={<WaypointsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/moderation" element={<ModerationPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/system" element={<SystemHealthPage />} />
          <Route path="/dev" element={<DevPage />} />
        </Routes>
      </DashboardLayout>
    </Box>
  )
}

export default App